/**
 * 输入框限制输入数字的长度
 * @param {*} el
 * @param {*} binding
 * @param {*} vnode
 */
export default function directiveMaxNumberLength(app) {
  app.directive('maxnumberlength', {
    inserted(el, binding, vnode) {
      const maxLength = parseInt(binding.value) || 1
      const inputEl = el.querySelector('input')
      if (!inputEl) return

      // 主处理函数（使用正则一次性完成过滤和截断）
      const handler = (event) => {
        const oldValue = event.target.value
        // 使用单个正则完成：1.去除非数字 2.截断长度
        const newValue = oldValue.replace(/[^0-9]/g, '').slice(0, maxLength)

        if (oldValue !== newValue) {
          event.target.value = newValue
          // 同步到Vue模型
          const setValue = (value) => {
            if (vnode.componentInstance) {
              vnode.componentInstance.$emit('input', value)
            } else if (vnode.elm) {
              vnode.elm.dispatchEvent(new Event('input'))
            }
          }
          setValue(newValue)
        }
      }

      // 事件监听
      const events = ['input', 'change', 'blur', 'keyup']
      events.forEach((e) => inputEl.addEventListener(e, handler))

      // 存储引用以便清理
      el._maxlengthHandlers = events.map((e) => ({ type: e, handler }))
    },

    unbind(el) {
      if (el._maxlengthHandlers) {
        const inputEl = el.querySelector('input')
        if (inputEl) {
          el._maxlengthHandlers.forEach(({ type, handler }) => {
            inputEl.removeEventListener(type, handler)
          })
        }
      }
    }
  })
}



// WEBPACK FOOTER //
// ./src/directive/maxNumberLength.js